import List from "./List.js";

export default { List };
